"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = require("prop-types");
var _react = _interopRequireDefault(require("react"));
var _reactFocusLock = _interopRequireDefault(require("react-focus-lock"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ModalService = _interopRequireDefault(require("./utils/ModalService"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const modalTypes = ['Sheets', 'Prompt', 'Theatre'];
const lockBody = prefix => {
  const body = document.body;
  _ModalService.default.push(true);
  if (body.classList.toString().indexOf(`${prefix}prevent-scroll-y`) === -1) {
    const scrollCache = window.pageYOffset || window.scrollY;
    body.setAttribute('data-skapa--scroll', scrollCache);
    const paddingCache = body.style.paddingRight;
    body.setAttribute('data-skapa--pad', paddingCache);
    let scrollbarWidth = body.clientWidth;
    body.classList.add(`${prefix}prevent-scroll-y`);
    scrollbarWidth = body.clientWidth - scrollbarWidth;
    body.style.top = `-${scrollCache}px`;
    if (scrollbarWidth) {
      body.style.paddingRight = `calc(${paddingCache || '0px'} + ${scrollbarWidth}px)`;
    }
    window.scrollTo(0, 0);
  }
};
const releaseBody = prefix => {
  const body = document.body;
  _ModalService.default.pop();
  if (_ModalService.default.length === 0 && body.classList.toString().indexOf(`${prefix}prevent-scroll-y`) > -1) {
    const scrollCache = body.getAttribute('data-skapa--scroll');
    const paddingCache = body.getAttribute('data-skapa--pad');
    body.classList.remove(`${prefix}prevent-scroll-y`);
    body.style.paddingRight = paddingCache;
    window.scrollTo(0, scrollCache);
    body.style.top = '';
    body.removeAttribute('data-skapa--scroll');
    body.removeAttribute('data-skapa--pad');
    if (!body.style.length) {
      body.removeAttribute('style');
    }
  }
  return true;
};
const elx = function () {
  for (var _len = arguments.length, listeners = new Array(_len), _key = 0; _key < _len; _key++) {
    listeners[_key] = arguments[_key];
  }
  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    return listeners.map(l => l && l(...args));
  };
};
const Modal = _ref => {
  let {
    className,
    visible,
    prefix,
    children,
    handleCloseBtn,
    focusLockProps,
    keepContentMounted,
    escapable,
    onModalClosed,
    onModalOpened,
    scrollLock,
    ...other
  } = _ref;
  const [isOpen, setIsOpen] = _react.default.useState(visible);
  const [animationMountHelper, setMount] = _react.default.useState(false);
  const animationFrameRef = _react.default.useRef(-1);
  const baseClass = `${prefix}modal-wrapper`;
  const leave = () => {
    setIsOpen(false);
    setMount(true);
  };
  const enter = () => {
    setIsOpen(true);
    if (scrollLock) lockBody(prefix);
  };
  const handleCloseRequest = event => {
    if (handleCloseBtn) {
      handleCloseBtn(event);
    } else {
      leave();
    }
  };
  const handleOnClick = event => {
    if (escapable && event.target === event.currentTarget) {
      handleCloseBtn(event);
    }
  };
  const escFunction = e => {
    const escapeCalledOnThisModal = !e.target.closest || e.target.closest(`.${baseClass}`) === e.currentTarget;
    if (escapeCalledOnThisModal && escapable && e.key === 'Escape') {
      handleCloseRequest(e);
    }
  };
  const handleAnimationEnd = e => {
    cancelAnimationFrame(animationFrameRef.current);
    if (isOpen) {
      if (onModalOpened) animationFrameRef.current = requestAnimationFrame(onModalOpened);
    } else if (animationMountHelper) {
      if (scrollLock) releaseBody(prefix);
      setMount(false);
      if (onModalClosed) animationFrameRef.current = requestAnimationFrame(onModalClosed);
    }
  };
  _react.default.useEffect(() => {
    if (visible !== isOpen) (visible ? enter : leave)();
  }, [visible]);
  _react.default.useEffect(() => {
    if (visible) enter();
    return () => {
      if (scrollLock) releaseBody(prefix);
      cancelAnimationFrame(animationFrameRef.current);
    };
  }, []);
  const overlayStyle = (0, _classnames.default)(baseClass, isOpen ? `${baseClass}--open` : `${baseClass}--close`, className);
  const backdropStyle = (0, _classnames.default)(`${baseClass}__backdrop`, `${baseClass}__backdrop--dark`);
  const hookedModal = _react.default.Children.map(children, child => _react.default.cloneElement(child, {
    open: isOpen,
    closeBtnClick: handleCloseBtn,
    prefix
  }));
  return _react.default.createElement("div", _extends({}, other, {
    onKeyDown: elx(other.onKeyDown, escFunction),
    className: overlayStyle,
    tabIndex: "-1",
    onAnimationEnd: handleAnimationEnd
  }), _react.default.createElement("div", {
    className: backdropStyle,
    onMouseDown: handleOnClick
  }), (keepContentMounted || isOpen || animationMountHelper) && _react.default.createElement(_reactFocusLock.default, _extends({
    returnFocus: true,
    autoFocus: true
  }, focusLockProps, {
    children: hookedModal
  })));
};
Modal.defaultProps = {
  prefix: '',
  focusLockProps: {},
  keepContentMounted: false,
  escapable: true,
  scrollLock: true
};
var _default = Modal;
exports.default = _default;